import { render, staticRenderFns } from "./upgradeSituationModel.vue?vue&type=template&id=560b8214&scoped=true&"
import script from "./upgradeSituationModel.vue?vue&type=script&lang=js&"
export * from "./upgradeSituationModel.vue?vue&type=script&lang=js&"
import style0 from "./upgradeSituationModel.vue?vue&type=style&index=0&id=560b8214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b8214",
  null
  
)

export default component.exports